import React from 'react'
import clsx from 'clsx'
import { FullWidthImageComponentProps } from './FullWidthImageComponentProps'
import ResponsiveImage from '../../utils/ResponsiveImage'
import useStyles from './FullWidthImageComponent.styles'

const FullWidthImageComponent: React.FC<FullWidthImageComponentProps> = ({
  image: { src }, index
}: FullWidthImageComponentProps) => {
  const classes = useStyles()
  // The image which index is 1 (the second component), is used as the hero image,
  // and it has no gap with the navigation header (the first component)
  const isHeroImage = index === 1
  return (
    <div className={clsx(isHeroImage && classes.heroImageContainer)}>
      <ResponsiveImage src={src} />
    </div>
  )
}

export default FullWidthImageComponent
